import { create } from 'zustand';

interface EventsListingStore {
  filters: string[];
  search: string;
  resultCount: number;
  maxResults: number;
}

export const eventFilterDefaultState = {
  filters: [],
  search: '',
  resultCount: 0,
  maxResults: 0,
};

const useEventListingStore = create<EventsListingStore>(() => eventFilterDefaultState);

const updateSearch = (search: string) => ({ search });

export const updateEventFilters = (value: string[]) => useEventListingStore.setState(() => ({ filters: value }));

export const setEventSearch = (search: string) => useEventListingStore.setState(() => updateSearch(search));

export const setResultCount = (resultCount: number) => useEventListingStore.setState(() => ({ resultCount }));

export const setMaxResults = (maxResults: number) => useEventListingStore.setState(() => ({ maxResults }));

export const clearEventFilters = () => useEventListingStore.setState(() => eventFilterDefaultState);

export default useEventListingStore;
